module.exports = __webpack_public_path__ + "static/media/logo-branca.d300cac6.png";